"use client";

import { Skeleton } from "@website/ui/skeleton";
import { deepCompare } from "@website/utils/deep-compare";
import { numberConvert } from "@website/utils/number-convert";
import { useCountDownTimer } from "@website/website-ui/hotel-last-second/count-down-timer/count-down-timer.hook";
import { FC, memo } from "react";

export type CountDownTimerType = {
  className?: string;
  chipClassName?: string;
  showTimer?: boolean;
  onTimeEnd?: () => void;
  resetOnEnd?: boolean;
  boxSize?: "small" | "large";
};

const Component: FC<CountDownTimerType> = ({
  showTimer = true,
  onTimeEnd,
  resetOnEnd,
  className = "",
  boxSize = "small"
}) => {
  const { timeLeft } = useCountDownTimer({ onTimeEnd, resetOnEnd });

  if (timeLeft && showTimer) {
    return (
      <div
        className={`mt-8 flex w-full justify-center gap-2 text-center ${className}`}
      >
        <div className={`flex items-center justify-center gap-2 text-center`}>
          <span className={`flex items-center gap-1`} dir="ltr">
            <div
              className={`flex ${
                boxSize === "small" ? "h-[28px] w-[38px]" : "size-10"
              } items-center justify-center rounded-lg bg-[#fff]`}
            >
              {numberConvert(timeLeft?.hours, { locale: "fa" })}
            </div>
            <div className="text-on-color-high-emphasis">:</div>
            <div
              className={`flex ${
                boxSize === "small" ? "h-[28px] w-[38px]" : "size-10"
              } items-center justify-center rounded-lg bg-[#fff]`}
            >
              {numberConvert(timeLeft?.minutes, { locale: "fa" })}
            </div>
            <div className="text-on-color-high-emphasis">:</div>
            <div
              className={`flex ${
                boxSize === "small" ? "h-[28px] w-[38px]" : "size-10"
              } items-center justify-center rounded-lg bg-[#fff]`}
            >
              {numberConvert(timeLeft?.seconds, { locale: "fa" })}
            </div>
          </span>
        </div>
      </div>
    );
  }
  return (
    <div className="h-[32px] w-full overflow-hidden rounded-full md:h-[28px] md:w-[145px]">
      <Skeleton height={32} />
    </div>
  );
};
export const CountDownTimerNewDesign = memo(Component, deepCompare);
